import { render, staticRenderFns } from "./UTextbooks.vue?vue&type=template&id=c8281086&"
import script from "./UTextbooks.vue?vue&type=script&lang=js&"
export * from "./UTextbooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports